export const actions = {
  PRODUCTOS_MAS_VENDIDOS_LOAD_REQUESTED: 'PRODUCTOS_MAS_VENDIDOS_LOAD_REQUESTED',
  PRODUCTOS_MAS_VENDIDOS_LOAD_SUCCEEDED: 'PRODUCTOS_MAS_VENDIDOS_LOAD_SUCCEEDED',
  PRODUCTOS_MAS_VENDIDOS_LOAD_FILED: 'PRODUCTOS_MAS_VENDIDOS_LOAD_FILED',

  PRODUCTOS_MAS_VENDIDOS_INSERT_REQUESTED: 'PRODUCTOS_MAS_VENDIDOS_INSERT_REQUESTED',
  PRODUCTOS_MAS_VENDIDOS_INSERT_SUCCEEDED: 'PRODUCTOS_MAS_VENDIDOS_INSERT_SUCCEEDED',
  PRODUCTOS_MAS_VENDIDOS_INSERT_FILED: 'PRODUCTOS_MAS_VENDIDOS_INSERT_FILED',

  PRODUCTOS_MAS_VENDIDOS_DELETE_REQUESTED: 'PRODUCTOS_MAS_VENDIDOS_DELETE_REQUESTED',
  PRODUCTOS_MAS_VENDIDOS_DELETE_SUCCEEDED: 'PRODUCTOS_MAS_VENDIDOS_DELETE_SUCCEEDED',
  PRODUCTOS_MAS_VENDIDOS_DELETE_FILED: 'PRODUCTOS_MAS_VENDIDOS_DELETE_FILED',

  PRODUCTOS_MAS_VENDIDOS_UPDATE_REQUESTED: 'PRODUCTOS_MAS_VENDIDOS_UPDATE_REQUESTED',
  PRODUCTOS_MAS_VENDIDOS_UPDATE_SUCCEEDED: 'PRODUCTOS_MAS_VENDIDOS_UPDATE_SUCCEEDED',
  PRODUCTOS_MAS_VENDIDOS_UPDATE_FAILED: 'PRODUCTOS_MAS_VENDIDOS_UPDATE_FAILED',
}
export const getProductosMasVendidosAction = (dispatch, idiomaId) => {
  dispatch({
    type: actions.PRODUCTOS_MAS_VENDIDOS_LOAD_REQUESTED,
    payload: idiomaId,
  })
}

export const insertProductosMasVendidosAction = (dispatch, payload) => {
  dispatch({
    type: actions.PRODUCTOS_MAS_VENDIDOS_INSERT_REQUESTED,
    payload,
  })
}

export const deleteProductosMasVendidosAction = (dispatch, payload) => {
  dispatch({
    type: actions.PRODUCTOS_MAS_VENDIDOS_DELETE_REQUESTED,
    payload,
  })
}

export const updateProductosMasVendidosAction = (dispatch, payload) => {
  dispatch({
    type: actions.PRODUCTOS_MAS_VENDIDOS_UPDATE_REQUESTED,
    payload,
  })
}
